import { render } from "./tplCouncil.vue?vue&type=template&id=09272c86&scoped=true"
import script from "./tplCouncil.vue?vue&type=script&lang=js"
export * from "./tplCouncil.vue?vue&type=script&lang=js"

import "./tplCouncil.vue?vue&type=style&index=0&id=09272c86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09272c86"]])

export default __exports__